import { render, staticRenderFns } from "./ModuleKnowlegeDetail.vue?vue&type=template&id=6ad8fc9a&scoped=true"
import script from "./ModuleKnowlegeDetail.vue?vue&type=script&lang=js"
export * from "./ModuleKnowlegeDetail.vue?vue&type=script&lang=js"
import style0 from "./ModuleKnowlegeDetail.vue?vue&type=style&index=0&id=6ad8fc9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad8fc9a",
  null
  
)

export default component.exports